<template>
  <nav class="account-navigation">
    <ul class="left-nav">
      <template v-if="hasCustomHeader">
        <slot name="custom-header"></slot>
      </template>
      <template v-else>
        <li v-if="heading" class="show-for-large left-nav-link-block left-nav-header-wrapper">
          <a :href="url">
            <h2 class="h1">{{ heading }}</h2>
          </a>
        </li>
      </template>
      <li v-for="link in links" :key="link.id" class="left-nav-link-block">
        <a :href="link.url">
          <h2>{{ link.name }}</h2>
          <span v-if="!link.submenu" class="hide-for-large"></span>
        </a>
        <template v-if="link.submenu">
          <ul class="submenu">
            <li v-for="sublink in link.submenu" :key="sublink.id">
              <a :href="sublink.url">
                <p>{{ sublink.name }}</p>
                <span class="hide-for-large"></span>
              </a>
            </li>
          </ul>
        </template>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { computed, useSlots } from 'vue';
import { links } from 'config';

defineProps({
  heading: {
    type: String,
    required: false,
    default: 'My Account',
  },
  url: {
    type: String,
    required: false,
    default: '/myaccount/home',
  },
});

const slots = useSlots();
const hasCustomHeader = computed(() => !!slots['custom-header']);
</script>

<style lang="scss" scoped>
.left-nav {
  margin-left: 0;
  li,
  :slotted(li) {
    list-style-type: none;
  }
}
.left-nav-header-wrapper,
:slotted(.left-nav-header-wrapper) {
  margin-bottom: rem-calc(30);
  border-bottom: rem-calc(1) solid $black;
}
a,
:slotted(a) {
  text-decoration: none;
  display: inline-block;
}
.left-nav-link-block,
:slotted(.left-nav-link-block) {
  margin-bottom: 1.25rem;
}
@include breakpoint(large down) {
  .left-nav {
    margin-top: rem-calc(30);
  }
  li {
    position: relative;
    .icon-front-sm-large {
      display: inline-block;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>

<style scoped brand="bcom">
p {
  margin-bottom: 1rem;
  font-size: inherit;
  line-height: 1.5rem;
  text-rendering: optimizeLegibility;
}
</style>

<style lang="scss" scoped brand="mcom">
a:hover,
a:focus,
:slotted(a:hover, a:focus) {
  color: $black;
  text-decoration: underline;
}

@include breakpoint(large down) {
  li {
    .icon-front-sm-large {
      right: rem-calc(10);
    }
    h2 {
      font-size: rem-calc(16);
      line-height: rem-calc(20);
    }
    p {
      font-size: rem-calc(12);
      line-height: rem-calc(16);
    }
  }
}
</style>
